import { Controller } from "@hotwired/stimulus";
import { useIntersection } from "stimulus-use";

/**
 * 使用例: data-controller="impression-cookie"
 *   data-impression-cookie-key-value="cookie_key"
 *   data-impression-cookie-url-value="<%= render_interval_path %>"
 */
export default class extends Controller {
  static values = {
    key: String,
    url: String,
  };

  #unobserve = null;

  connect() {
    if (!this.hasKeyValue || !this.hasUrlValue) {
      console.error("Missing key/url value", this.element);
      return;
    }

    // 要素全体の表示で発火させる
    const [, unobserve] = useIntersection(this);
    this.#unobserve = unobserve;
  }

  disconnect() {
    this.#stopObserve();
  }

  appear() {
    // `appear()` のコールバックを一度だけ実行する
    this.#stopObserve();
    this.#touchCookie();
  }

  #stopObserve() {
    if (!this.#unobserve) {
      return;
    }

    this.#unobserve();
    this.#unobserve = null;
  }

  /**
   * JSからCookieの操作をすると有効期間が7日になってしまう(safari)
   * クッキーを更新するだけのURLを叩きにいく
   */
  #touchCookie() {
    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
      body: JSON.stringify({ key: this.keyValue }),
    });
  }
}
